import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";

interface AdvancedSettingsProps {
  keyValue: string | null;
  onKeyChange: (newKey: string) => void;
}

export const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({ keyValue, onKeyChange }) => {
  const [localKey, setLocalKey] = useState(keyValue ?? "");

  useEffect(() => {
    setLocalKey(keyValue ?? "");
  }, [keyValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalKey(e.target.value);
    onKeyChange(e.target.value);
  };

  return (
    <Box sx={{ padding: (theme) => `${theme.spacing(3)} ${theme.spacing(5.5)}` }}>
      <TextField label="Key" value={localKey} onChange={handleChange} fullWidth size="small" />
    </Box>
  );
};

export default AdvancedSettings;
